import { render, staticRenderFns } from "./AllModule.vue?vue&type=template&id=b82f5c5c&scoped=true"
import script from "./AllModule.vue?vue&type=script&lang=js"
export * from "./AllModule.vue?vue&type=script&lang=js"
import style0 from "./AllModule.vue?vue&type=style&index=0&id=b82f5c5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82f5c5c",
  null
  
)

export default component.exports